<div class="row page-header">
    <div class="col-12">
        <h1>Subcontractor Training <small>Manage training modules and track subcontractor completions</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        <li [ngbNavItem]="0" [destroyOnHide]="false">
            <a ngbNavLink>Dashboard</a>
        </li>
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Invitations &amp; Tracking</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Training Modules</a>
        </li>
    </ul>

    <div [hidden]="!isDashboardTab">
        <app-subcontractor-training-dashboard
            [availableModules]="availableModules"
            (ready)="onDashboardReady()"
            (viewInviteDetails)="viewInviteDetailsById($event)"
        ></app-subcontractor-training-dashboard>
    </div>

    <div [hidden]="!isTrackingTab">
        <div class="card mb-4">
            <div class="card-header">
                <strong>Send Training Invite</strong>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group mb-3">
                            <label>Subcontractor Company</label>
                            <input type="text" class="form-control" [(ngModel)]="inviteRequest.companyName" name="companyName" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group mb-3">
                            <label>Email</label>
                            <input type="email" class="form-control" [(ngModel)]="inviteRequest.email" name="email" />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-3">
                            <label>Contact First Name (optional)</label>
                            <input type="text" class="form-control" [(ngModel)]="inviteRequest.firstName" name="firstName" />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-3">
                            <label>Contact Last Name (optional)</label>
                            <input type="text" class="form-control" [(ngModel)]="inviteRequest.lastName" name="lastName" />
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label class="d-block mb-2">Training Modules</label>
                    @if (availableModules.length === 0) {
                        <p class="text-muted mb-0">No active training modules available.</p>
                    } @else {
                        <div class="row">
                            @for (module of availableModules; track module.id) {
                                <div class="col-md-4">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            [id]="'module-' + module.id"
                                            [checked]="selectedModuleIds.includes(module.id)"
                                            (change)="toggleModuleSelection(module.id, $any($event.target).checked)"
                                        />
                                        <label class="form-check-label" [for]="'module-' + module.id">{{ module.title }}</label>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
                <button type="button" class="btn btn-primary" [disabled]="!canEdit || isSendingInvite" (click)="sendInvite()">
                    @if (isSendingInvite) {
                        Sending...
                    } @else {
                        Send Invite
                    }
                </button>
            </div>
        </div>

        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="trackingGrid"></action-toolbar-count>
                    <action-toolbar-buttons [grid]="trackingGrid" [canEdit]="canEdit" [showDelete]="true"></action-toolbar-buttons>
                    <button type="button" class="btn btn-sm btn-secondary" (click)="refreshTracking()">Refresh</button>
                    <action-toolbar-search name="trackingSearch" [(ngModel)]="trackingGrid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="trackingGrid"
                    #trackingGridRef
                    appAutoSize
                    (initialized)="trackingGrid.initialize(trackingGridRef)"
                    (destroy)="trackingGrid.destroy()"
                    [itemsSource]="trackingGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Company'" [binding]="'companyName'" [width]="160"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Email'" [binding]="'email'" [width]="200"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Name'" [binding]="'participantFirstName'" [width]="140">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            {{ getParticipantName(cell.item) }}
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Modules'" [binding]="'moduleTitles'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="110"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Invited On'" [binding]="'invitedOn'" [width]="130">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            {{ cell.item.invitedOn | date: 'mediumDate' }}
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Overdue'" [binding]="'isOverdue'" [width]="105">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            @if (cell.item.isOverdue) {
                                <span class="badge text-bg-danger">Yes</span>
                            }
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Latest Completion'" [binding]="'latestCompletionOn'" [width]="170">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            {{ cell.item.latestCompletionOn | date: 'medium' }}
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Details'" [binding]="'inviteId'" [width]="90">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <button type="button" class="btn btn-sm btn-link p-0" (click)="viewTrackingDetails(cell.item)">View</button>
                        </ng-template>
                    </wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>

    <div [hidden]="!isModulesTab">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="moduleGrid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="moduleGrid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="moduleSearch" [(ngModel)]="moduleGrid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="moduleGrid"
                    #moduleGridRef
                    appAutoSize
                    (initialized)="moduleGrid.initialize(moduleGridRef)"
                    (destroy)="moduleGrid.destroy()"
                    [itemsSource]="moduleGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Active'" [binding]="'isActive'" [width]="80"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Sort'" [binding]="'sortOrder'" [width]="70"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Questions'" [binding]="'questions'" [width]="100">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            {{ cell.item.questions?.length ?? 0 }}
                        </ng-template>
                    </wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
